import { memo } from 'react'
import i18n from '../../../../utilities/i18n'
import type { IconProps } from '../../../Icons'
import TrendingIcon from '../../../Icons/Trending'
import { palette } from '../../../styles/colors'
import Container from '../Container'

interface TrendingBadgeProps extends IconProps {
    shadow?: boolean
    size?: number
}

const TrendingBadge = memo((props: TrendingBadgeProps) => {
    const { shadow, size = 0.8, ...other } = props

    return (
        <Container title="Trending" shadow={shadow}>
            <TrendingIcon
                title={i18n.t('settings.pinToTop.trending')}
                color={palette.badgeTrending}
                size={size}
                {...other}
            />
        </Container>
    )
})

export default TrendingBadge
export { TrendingBadge }
